import React, { useState } from 'react';
import { TextField, Button, Typography, Select, MenuItem, FormControl, InputLabel, Box, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft } from 'lucide-react';
import toast from 'react-hot-toast';

const POCreateStep1 = () => {
  const [poName, setPoName] = useState('');
  const [platform, setPlatform] = useState('Shopify');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleCreatePO = async () => {
    if (!poName) { toast.error('Name is required'); return; }
    if (isSubmitting) return;
    setIsSubmitting(true);
    const t = toast.loading('Creating purchase list…');
    try {
      const response = await axios.post('https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/pos', {
        poName, platform, products: [],
      });
      toast.success('Purchase list created', { id: t });
      navigate(`/po-edit/${response.data._id}`);
    } catch (error) {
      console.error('Error creating PO:', error);
      toast.error('Failed to create purchase list', { id: t });
    }
    finally { setIsSubmitting(false); }
  };

  return (
    <Box className="fade-in" sx={{ maxWidth: 480 }}>
      <Button onClick={() => navigate(-1)} startIcon={<ArrowLeft size={16} />}
        sx={{ mb: 2, color: 'text.secondary', fontWeight: 500 }}>Back</Button>

      <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: '-0.02em', mb: 0.5 }}>
        Create Purchase List
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 4 }}>
        Set up a new purchase list for tracking orders
      </Typography>

      <Stack spacing={2.5}>
        <Box>
          <Typography variant="caption" sx={{ fontWeight: 500, color: 'text.secondary', display: 'block', mb: 0.5 }}>Name</Typography>
          <TextField fullWidth size="small" placeholder="Purchase list name" value={poName} onChange={(e) => setPoName(e.target.value)} />
        </Box>
        <Box>
          <Typography variant="caption" sx={{ fontWeight: 500, color: 'text.secondary', display: 'block', mb: 0.5 }}>Platform</Typography>
          <FormControl fullWidth size="small">
            <Select value={platform} onChange={(e) => setPlatform(e.target.value)}>
              <MenuItem value="Shopify">Shopify</MenuItem>
              <MenuItem value="Amazon">Amazon</MenuItem>
              <MenuItem value="Walmart">Walmart</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ display: 'flex', gap: 1.5, pt: 1 }}>
          <Button variant="contained" onClick={handleCreatePO} disabled={isSubmitting}
            sx={{ bgcolor: '#2383e2', '&:hover': { bgcolor: '#1b6ec2' }, px: 3 }}>
            Create
          </Button>
          <Button variant="outlined" onClick={() => navigate(-1)} disabled={isSubmitting}>
            Cancel
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

export default POCreateStep1;
